import React, { Component } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import i18n from "i18next";
import menuPages from "../../menuPages";
import _helper from "../../actions/_helper";
import "./Sidebar.css";

class Sidebar extends Component {
  inserMenuItems(items, page) {
    return items.map(({ link, Icon }) => {
      const text = link.replace("/app/", "");
      const active = link.includes(page);

      return (
        <Box className={`nav-item ${active ? "active" : ""}`} key={link}>
          <Tooltip
            title={i18n.t(`pages.${text}`)}
            placement="right"
            arrow
            disableHoverListener={this.props.expanded}>
            <Box className="nav-btn-wrap">
              <IconButton
                component={Link}
                to={link}
                className={`nav-btn ${active ? "active" : ""}`}
                size="large"
                sx={{ borderRadius: "10px", p: 0 }}
                aria-label={i18n.t(`pages.${text}`)}
                disableRipple
                disableFocusRipple
                disableTouchRipple
                aria-current={active ? "page" : undefined}>
                <Icon fontSize="inherit" />
              </IconButton>
              {this.props.expanded && (
                <Typography className="nav-label" noWrap>
                  {i18n.t(`pages.${text}`)}
                </Typography>
              )}
            </Box>
          </Tooltip>
        </Box>
      );
    });
  }

  render() {
    const { page } = _helper.getPageTitle();

    const top = menuPages.menu.filter((it) => !it.isBottom);
    const bottom = menuPages.menu.filter((it) => it.isBottom);

    return (
      <Box className={`sidebar ${this.props.expanded ? "expanded" : ""}`}>
        <Box className="nav-group top">{this.inserMenuItems(top, page)}</Box>
        <Box className="spacer" />
        <Box className="nav-group bottom">
          {this.inserMenuItems(bottom, page)}
        </Box>
      </Box>
    );
  }
}

export default Sidebar;
